import React from 'react';
import apiCall from "../apiCall";
import getUrlVars from '../../helpers/getUrlVars';
import tabInfo from '../../helpers/tabInfo';
import forward from '../../assets/img/icons/forward-10.svg';
import replay from '../../assets/img/icons/replay-10.svg';
import ContentContainer from "../elements/ContentContainer";

class Audio extends React.Component {
  static defaultProps = {
    desktop: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      gameMaterial: null,
    }
  }

  componentWillMount() {
    this.fetchMaterials();

    const getParams = getUrlVars();
    if (getParams.windowTitle && getParams.windowTitle !== 'null') {
      tabInfo.setWindowTitle(decodeURIComponent(getParams.windowTitle));
    }
    if (getParams.faviconUrl && getParams.faviconUrl !== 'null') {
      tabInfo.setFavicon(decodeURIComponent(getParams.faviconUrl));
    }
  }

  fetchMaterials() {
    const { audioId } = this.props.match.params;
    apiCall(`/file/${audioId}`, null, 'GET')
      .then((material) => {
        this.setState({ gameMaterial: material});
      });
  }

  scrubAudio = (time) => {
    this.refs.audio.currentTime += time;
  }

  render() {
    const { gameMaterial } = this.state;
    return (
      <div className={this.props.desktop ? 'portal-vimeo portal-home darkBckg' : 'portal-vimeo portal-home darkBckg'}>
        {gameMaterial && gameMaterial.url ? (
          <div className={"portal-audio-container"} style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}>
            <ContentContainer style={{margin: "0 auto"}}>
              <h3 style={{textAlign: 'center', marginBottom: "20px"}}>{gameMaterial.filename}</h3>
              <audio ref="audio" controls autoPlay={false}>
                <source src={gameMaterial.url} />
              </audio>
              <div className={'countdown-controls'}>
                <div style={{cursor: "pointer"}} className={'icon'} onClick={() => this.scrubAudio(-10)}>
                  <img src={replay} alt={"rewind"}/>
                </div>
                <div style={{cursor: "pointer"}} className={'icon'} onClick={() => this.scrubAudio(10)}>
                  <img src={forward} alt={"fast forward"}/>
                </div>
              </div>
            </ContentContainer>
          </div>
        ) : null}
      </div>
    );
  }
}

export default Audio;



// WEBPACK FOOTER //
// ./src/components/routes/Audio.js